module.exports = __webpack_public_path__ + "assets/img/free_6.b82132d8.png";